import * as React from 'react'
import PropTypes from 'prop-types'

const Switch = React.forwardRef(({ className, checked, onCheckedChange, disabled, ...props }, ref) => {
  const handleChange = (e) => {
    if (onCheckedChange) {
      onCheckedChange(e.target.checked)
    }
  }

  return (
    <label
      className={`relative inline-block w-11 h-7 cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${
        className || ''
      }`}
    >
      <input
        type="checkbox"
        className="sr-only"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        ref={ref}
        {...props}
      />
      <span
        className={`absolute top-1 inset-0 rounded-full transition-colors duration-200 ease-in-out ${
          checked ? 'bg-purple-600' : 'bg-gray-200'
        }`}
      ></span>
      <span
        className="absolute top-1.5 left-0.5 bg-white w-5 h-5 rounded-full shadow z-10 transition-all duration-200 ease-in-out"
        style={{
          transform: checked ? 'translateX(20px)' : 'translateX(0px)'
        }}
      ></span>
    </label>
  )
})

Switch.displayName = 'Switch'

Switch.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool,
  onCheckedChange: PropTypes.func,
  disabled: PropTypes.bool
}

Switch.defaultProps = {
  checked: false,
  disabled: false
}

export { Switch }
